export default function ComplianceIcon() {
  return (
    <svg width="106" height="93" viewBox="0 0 106 93" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M60 110C87.6142 110 110 87.6142 110 60C110 32.3858 87.6142 10 60 10C32.3858 10 10 32.3858 10 60C10 87.6142 32.3858 110 60 110Z"
        fill="url(#paint0_linear_469_6868)"
      />
      <path
        d="M75 80C72.2 80 69.95 77.75 69.95 75C69.95 72.25 72.2 70 74.95 70C77.7 70 79.95 72.25 79.95 75C79.95 77.75 77.75 80 75 80Z"
        fill="url(#paint1_linear_469_6868)"
      />
      <path
        d="M45.05 50C42.25 50 40 47.75 40 45C40 42.25 42.25 40 45 40C47.75 40 50 42.25 50 45C50 47.75 47.8 50 45.05 50Z"
        fill="url(#paint2_linear_469_6868)"
      />
      <path
        d="M44.9999 78.7499C44.0499 78.7499 43.0997 78.4 42.3497 77.65C40.8997 76.2 40.8997 73.7997 42.3497 72.3497L72.3497 42.3497C73.7997 40.8997 76.2 40.8997 77.65 42.3497C79.1 43.7997 79.1 46.2 77.65 47.65L47.65 77.65C46.9 78.4 45.9499 78.7499 44.9999 78.7499Z"
        fill="url(#paint3_linear_469_6868)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_469_6868"
          x1="18.7904"
          y1="60.0005"
          x2="100.88"
          y2="60.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_469_6868"
          x1="70.829"
          y1="75.0001"
          x2="79.0379"
          y2="75.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_469_6868"
          x1="40.879"
          y1="45.0001"
          x2="49.088"
          y2="45.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_469_6868"
          x1="44.5564"
          y1="60.0062"
          x2="75.3196"
          y2="60.0062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CDF7" stop-opacity="0.5" />
          <stop offset="1" stop-color="#CDDFF0" stop-opacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
